import { useEffect } from "react";

import { Box } from "@mui/material";

import useBrowser from "../../hooks/useBrowser";

import Modal from "./Modal";

import SurveyPageEditor from "../editors/SurveyPageEditor";

const SurveyPageModal = ({
  surveyId,
  page,
  open,
  onClose,
  onSave,
  canDelete = false,
}) => {
  const { windowHeight } = useBrowser();

  return (
    <Modal
      title={page?.name || "New Survey Page"}
      open={open}
      onClose={onClose}
      width="600px"
      height={`${windowHeight}px`}
    >
      <SurveyPageEditor
        onSave={onSave}
        surveyId={surveyId}
        page={page}
        canDelete={canDelete}
      />
    </Modal>
  );
};

export default SurveyPageModal;
